import "./chatuserlist.scss";
import Chatlist from "../chatlist/Chatlist";
import Chatuserinfor from "../chatuserinfor/Chatuserinfor";

const Chatuserlist = () => {
  return (
    <div className="chatuserlist">
        <Chatuserinfor />
        <Chatlist />
    </div>
  )
}

export default Chatuserlist